<div *ngIf="navData" fxLayoutGap="10px" class="data-wrap pt-0" fxLayout="column">
    <div class="title mt-0" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <mat-icon class="title-icon dark-blue {{ navData.data.class }}">{{ navData.data.icon }}</mat-icon>
        <div class="title-label dark-blue {{ navData.data.class }}" fxFlex="grow">{{ navData.data.title }}</div>
    </div>

    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
        <app-image-view
            [ngStyle]="{ minWidth: '110px' }"
            [media_id]="navData.data.resource.media"
            paddingBottom="70px"
        ></app-image-view>
        <div fxLayout="column" fxLayoutAlign="center start">
            <span class="dark-blue res-title">{{ navData.data.resource.title }}</span>
        </div>
    </div>

    <div class="dates" *ngIf="resourceOccDates?.length == 1">
        <mat-icon class="date-icon">today</mat-icon>
        <span>{{ resourceOccDates[0].start_date | kdDateFormat : 'MMM DD, YYYY HH:mm' }}</span>
        <span>-</span>
        <span>{{ resourceOccDates[0].end_date | kdDateFormat : 'MMM DD, YYYY HH:mm' }}</span>
        <span>{{ navData.data.resource.time_zone }}</span>
    </div>
    <div
        fxLayoutAlign="start start"
        fxLayoutGap="5px"
        fxLayout="column"
        *ngIf="resourceOccDates?.length > 1 && !resource.opportunity_id"
    >
        <span i18n>Please select joining date</span>
        <mat-radio-group
            fxLayout="column"
            [formControl]="eventOccasionId"
            class="item"
            fxLayoutAlign="start center"
            fxLayoutGap="5px"
        >
            <mat-radio-button
                [disabled]="occ.selected || occ.ispassed"
                class="dates"
                *ngFor="let occ of resourceOccDates"
                [value]="occ.id"
            >
                <mat-icon class="date-icon">today</mat-icon>
                <span>{{ occ.start_date | kdDateFormat : 'MMM DD, YYYY HH:mm' }}</span>
                <span>-</span>
                <span>{{ occ.end_date | kdDateFormat : 'MMM DD, YYYY HH:mm' }}</span>
                <span>{{ navData.data.resource.time_zone }}</span>
            </mat-radio-button>
        </mat-radio-group>
    </div>
    <div class="desc">{{ navData.data.contentBody }}</div>
</div>
<ng-container [ngTemplateOutlet]="actions"></ng-container>
<ng-template #actions>
    <div
        class="action p-10"
        fxLayout="row-reverse"
        fxLayoutAlign="start center"
        fxLayoutGap="10px"
        [class.disableIt]="showGroupWork || showGroups"
    >
        <button
            *ngIf="!resource.opportunity_id"
            [disabled]="resourceOccDates?.length > 1 && !eventOccasionId.value"
            fxFlex="0 0 auto"
            class="mobile-button positive pos-btn"
            (click)="onJoin()"
            mat-button
            i18n
        >
            Join
        </button>
        <button fxFlex="0 0 auto" class="mobile-button positive" (click)="onSignOff()" mat-button i18n>Signoff</button>
        <button fxFlex="0 0 auto" class="mobile-button null-btn" (click)="onClose.emit(null)" mat-button i18n>
            Cancel
        </button>
    </div>
    <div *ngIf="showGroupWork" class="mt-1 p-10" fxLayout="column" fxLayoutAlign="center end" fxLayoutGap="10px">
        <div *ngIf="action === 'start'" class="desc" i18n>
            Did you take this {{ navData.data.resource | resourceDefaultNameDisplay : false | async }} by yourself or
            with a group?
        </div>
        <div *ngIf="action === 'signoff'" class="desc" i18n>
            Did you signoff this {{ navData.data.resource | resourceDefaultNameDisplay : false | async }} by yourself or
            with a group?
        </div>
        <div
            [class.disableIt]="showGroups || showEGKAloneCheck"
            class="action"
            fxLayout="row-reverse"
            fxLayoutAlign="start center"
            fxLayoutGap="10px"
        >
            <button
                *ngIf="action === 'start'"
                fxFlex="0 0 auto"
                class="mobile-button positive"
                (click)="onDone()"
                mat-raised-button
                i18n
            >
                By myself
            </button>
            <button
                *ngIf="action === 'signoff'"
                fxFlex="0 0 auto"
                class="mobile-button positive"
                (click)="!navData.data.isEKGOpp ? onDoneSignOff() : (showEGKAloneCheck = true)"
                mat-raised-button
                i18n
            >
                By myself
            </button>
            <button fxFlex="0 0 auto" class="mobile-button negative" (click)="showGroups = true" mat-button i18n>
                With a group
            </button>
            <button
                fxFlex="0 0 auto"
                class="mobile-button negative"
                (click)="showGroupWork = false; showGroups = false; action = null"
                mat-button
                i18n
            >
                Cancel
            </button>
        </div>
    </div>
    <div
        class="w-100 mt-1 p-10"
        *ngIf="showEGKAloneCheck"
        fxLayout="column"
        fxLayoutAlign="center end"
        fxLayoutGap="10px"
    >
        <mat-checkbox [formControl]="passedEGKCheckControl">I've passed the EGK exam</mat-checkbox>
        <div class="action" fxLayout="row-reverse" fxLayoutAlign="start center" fxLayoutGap="10px">
            <button
                fxFlex="0 0 auto"
                class="mobile-button positive"
                (click)="sendClearSignOffWithEGK()"
                mat-raised-button
                i18n
            >
                Signoff
            </button>
            <button
                fxFlex="0 0 auto"
                class="mobile-button negative"
                (click)="showEGKAloneCheck = false"
                mat-button
                i18n
            >
                Cancel
            </button>
        </div>
    </div>
    <div class="w-100 mt-1 p-10" *ngIf="showGroups" fxLayout="column" fxLayoutAlign="center end" fxLayoutGap="10px">
        <app-user-search-chips-display
            *ngIf="!navData.data.isEKGOpp || action === 'start'"
            [user]="navData.data.user"
            (onUpdateSelectiedUsers)="updateParticipantUsers($event)"
        ></app-user-search-chips-display>
        <app-user-chip-display-with-select
            *ngIf="navData.data.isEKGOpp && action === 'signoff'"
            [user]="navData.data.user"
            (onUpdateSelectiedUsersWithSelect)="updateParticipantUsersWithSelect($event)"
        ></app-user-chip-display-with-select>
        <app-occasion-spend-time
            *ngIf="action === 'signoff'"
            label="Time spent for this groupwork"
            i18n-label="@@spendTimeForThisGroupWork"
            [occasion]="navData.data.occasion"
            [formControl]="timeSpendControl"
        ></app-occasion-spend-time>
        <div class="action mt-1" fxLayout="row-reverse" fxLayoutAlign="start center" fxLayoutGap="10px">
            <button
                fxFlex="0 0 auto"
                [disabled]="!participantUsersWithSelect.length && !participantUsers.length"
                class="mobile-button positive"
                (click)="submit()"
                mat-raised-button
                i18n
            >
                Done
            </button>

            <button
                fxFlex="0 0 auto"
                class="mobile-button negative"
                (click)="action === 'start' ? onDone() : action === 'signoff' ? sendClearSignOff() : onClose.emit(null)"
                mat-button
                i18n
            >
                Close
            </button>
            <button fxFlex="0 0 auto" class="mobile-button negative" (click)="showGroups = false" mat-button i18n>
                Cancel
            </button>
        </div>
    </div>
</ng-template>
